export const query = document.querySelector.bind(document);
export const queryAll = document.querySelectorAll.bind(document);
Node.prototype.on = window.on = function (name, fn) {
    this.addEventListener(name, fn);
};
Node.prototype.off = window.off = function (name, fn) {
    this.removeEventListener(name, fn);
};
